import { Group, Text } from '@mantine/core';
import { PiCaretDownBold } from 'react-icons/pi';
import { useState, Fragment } from 'react';
import cn from 'clsx';

export function Rows({
  items,
  withExpand = false,
}: {
  items: { label: string; value: React.ReactNode; showValueAsRow?: boolean }[];
  withExpand?: boolean;
}) {
  const [expanded, setExpanded] = useState(!withExpand);

  const itemsToRender = expanded ? items : items.slice(0, 1);

  return itemsToRender.map((item, index) => {
    if (item.showValueAsRow) {
      return <Fragment key={item.label}>{item.value}</Fragment>;
    }
    return (
      <Fragment key={item.label}>
        <Group justify="space-between">
          <Text fz={14} c="#7B7B7B">
            {item.label}:
          </Text>
          <Group gap={8}>
            <Text fz={14}>{item.value}</Text>
            {withExpand && index === 0 && items.length > 1 && (
              <PiCaretDownBold
                size={16}
                className={cn(
                  'cursor-pointer transition-transform',
                  expanded && 'rotate-180'
                )}
                onClick={() => setExpanded(!expanded)}
              />
            )}
          </Group>
        </Group>
        {/* {expanded && index === 0 && <div className="h-[1px] bg-main1/[0.14]" />} */}
      </Fragment>
    );
  });
}
